// TODO: for now used here, but after updating initial endpoint to return same structure, can be moved
export enum GameItemType {
    BALL = 1,
    DICE = 2,
    WHEEL_SECTOR = 3,
    SHOVA = 5,
}
